"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessEnvWrapper = void 0;
class ProcessEnvWrapper {
    static getInstance() {
        if (!this._instance) {
            this._instance = new ProcessEnvWrapper(process.env);
        }
        return this._instance;
    }
    overrideEnv(overrides) {
        this._overrides = overrides;
    }
    clearOverrides() {
        this._overrides = undefined;
    }
    constructor(processEnv) {
        this._processEnv = processEnv;
        this._overrides = undefined;
    }
    getValue(path) {
        const environment = this._overrides || this._processEnv;
        return environment[path] || undefined;
    }
    getValueOrNull(path) {
        return this.getValue(path) || null;
    }
    getValueOrDefault(path, defaultValue) {
        return this.getValue(path) || defaultValue;
    }
    getValueOrThrow(path) {
        const value = this.getValue(path);
        if (!value) {
            throw new Error(`process.env.${path} is not defined but is required for service to be healthy`);
        }
        return value;
    }
    /**
     * Whether an environment variable has truthy values, useful for feature toggles
     *
     * @param path
     */
    isEnabled(path, defaultValue = false) {
        const value = this.getValueOrDefault(path, defaultValue.toString());
        return !!value && !!value.match(/true|on/i);
    }
    isDevelopmentEnvironment() {
        const nodeEnv = this.getValueOrDefault('NODE_ENV', 'development').toLowerCase();
        return nodeEnv === 'development' || nodeEnv === 'dev';
    }
    isProductionEnvironment() {
        const nodeEnv = this.getValueOrDefault('NODE_ENV', 'development').toLowerCase();
        return nodeEnv === 'production' || nodeEnv === 'prod';
    }
}
exports.ProcessEnvWrapper = ProcessEnvWrapper;
const _instance = ProcessEnvWrapper.getInstance();
exports.default = _instance;
